export default class UmbracoForms {
  constructor(element) {
    this.el = element;
    this.formSubmit = this.el.querySelector("input[type='submit']");
    this.formRecaptcha = this.el.querySelector(".recaptcha2");
    this.emailField = this.el.querySelector("input[type='email']");
    this.phoneField = this.el.querySelector("input[type='tel']");
    this.formErrors = null;
    this.init();
  }

  init() {
    if (this.formRecaptcha) {
      const recaptchaError = this.formRecaptcha.querySelector(".field-validation-error");
      if (recaptchaError) {
        this.el.scrollIntoView({ block: 'center' });
      }
    }

    this.formSubmit.addEventListener("click", (e) => {
      setTimeout(() => {
        this.formErrors = this.el.querySelectorAll(".input-validation-error");

        if (!this.formErrors.length) {
          if (this.formRecaptcha) {
            const recaptchaError = this.formRecaptcha.querySelector(".field-validation-error");
            if (!recaptchaError) {
              const submissionData = {
                event: "ec_form_submit",
                formId: this.el.id,
                user_data: {
                  email: this.emailField ? this.emailField.value : null,
                  phone: this.phoneField ? this.phoneField.value : null
                }
              };
              sessionStorage.setItem(
                'ec_form_submit',
                JSON.stringify(submissionData)
              );

              console.log("Stored form data in sessionStorage:", submissionData);
            }
            return;
          }

          const submissionData = {
            event: "ec_form_submit",
            formId: this.el.id,
            user_data: {
              email: this.emailField ? this.emailField.value : null,
              phone: this.phoneField ? this.phoneField.value : null
            }
          };

          sessionStorage.setItem(
            'ec_form_submit',
            JSON.stringify(submissionData)
          );

          console.log("Stored form data in sessionStorage:", submissionData);
        }

        console.log("formSubmit clicked");
      }, 50);
    });
  }
}
